import { render, staticRenderFns } from "./PostProcessing.vue?vue&type=template&id=2e6e7d00&scoped=true&"
var script = {}
import style0 from "./PostProcessing.vue?vue&type=style&index=0&id=2e6e7d00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6e7d00",
  null
  
)

export default component.exports